module.exports = __webpack_public_path__ + "static/fretlink-process-342fd1fc83ee205a115ff6cebeae59e4.png";